var styles = {"container":"DataTable_container_c4532130","withBorder":"DataTable_withBorder_c4532130","table":"DataTable_table_c4532130","layoutAuto":"DataTable_layoutAuto_c4532130","skeleton":"DataTable_skeleton_c4532130","alignCenter":"DataTable_alignCenter_c4532130","alignRight":"DataTable_alignRight_c4532130","visuallyHidden":"DataTable_visuallyHidden_c4532130"};

export { styles as s };
